import { RadioInner, RadioOuter } from './styles'

/** 카드 등록 폼 라디오 (개인/법인 선택) */
export function Radio({ selected }: { selected: boolean }) {
  return <RadioOuter selected={selected}>{selected && <RadioInner />}</RadioOuter>
}
